import React from "react";
import { BoxTitle } from "../../../../styles/texts";


interface ProductionPieChartProps {
  consumido: number;
  vendido: number;
}


const ProductionPieChart: React.FC<ProductionPieChartProps> = ({ consumido, vendido }) => {

  // consumido = 10;
  // vendido = 20;
  console.log("PPC consumido:", consumido, vendido);

  const radio = 140;
  const diametro = 2 * Math.PI * radio;
  const strokeWidth = 30;
  const gapRatio =  2 * strokeWidth / diametro;

  const total = parseFloat((consumido + vendido).toFixed(2));
  const minPercentage = 0.07; // sino, explota la visualizacion

  let porcentajeConsumido = 0.5; // si total es cero
  let porcentajeVendido = 0.5; // si total es cero
  if (total > 0) {
    porcentajeConsumido = consumido / total;
    porcentajeVendido = vendido / total;
  }
  if (porcentajeConsumido < minPercentage) {
    porcentajeConsumido = minPercentage;
    porcentajeVendido = 1 - porcentajeConsumido;
  }
  if (porcentajeVendido < minPercentage) {
    porcentajeVendido = minPercentage;
    porcentajeConsumido = 1 - porcentajeVendido;
  }
  
  const segmentoConsumidoOffset = (porcentajeVendido + gapRatio) * diametro; // longitud
  const segmentoVendidoOffset = (porcentajeConsumido + gapRatio) * diametro; // longitud
  const rotacionConsumido = (0 + porcentajeVendido + gapRatio) * 180; // grados
  const rotacionVendido = (1 + porcentajeConsumido + gapRatio) * 180; // grados
  
  //console.log("rotaciones:", rotacionConsumido, rotacionVendido);
  //console.log("offsets:", segmentoConsumidoOffset, segmentoVendidoOffset);
  return (
    <div className="relative flex items-center justify-center overflow-visible ml-6 mr-6">
      
      <div className="absolute flex flex-col items-center justify-center w-full">
        <BoxTitle>{total}</BoxTitle>
        <div>kWh</div>
      </div>
      
      {/* Chart */}
      <div className="relative">
        <svg width="100" height="100" viewBox="0 0 200 200" style={{ overflow: 'visible' }}>


          {/* Consumed segment */}
          {porcentajeConsumido > 0 && (
            <circle
              cx="100"
              cy="100"
              r={radio}
              fill="none"
              stroke= "#5A6ED5"
              strokeWidth={strokeWidth}
              strokeDasharray={diametro}
              strokeDashoffset={segmentoConsumidoOffset}
              strokeLinecap="round"
              transform = {`rotate( ${rotacionConsumido} 100 100 )`}
            />
          )}
          
          {/* Sold segment */}
          { porcentajeVendido > 0 && (
            <circle
              cx="100"
              cy="100"
              r={radio}
              fill="none"
              stroke= "#293C9D"
              strokeWidth={strokeWidth}
              strokeDasharray={diametro}
              strokeDashoffset={segmentoVendidoOffset}
              strokeLinecap="round"
              transform = {`rotate( ${rotacionVendido} 100 100 )`}
            />
          )}

        </svg>
      </div>

    </div>
  );
};

export default ProductionPieChart;

 